import { gql, mutate, watchQuery } from '@/services/apollo'

const GET_GAMES = gql`
  query GamePage($input: GamePageInput!) {
    gamePage(input: $input) {
      game {
        id
        name
        gameId
      }
      totalCount
    }
  }
`

const CREATE_GAME = gql`
  mutation CreateGame($input: CreateGameInput!) {
    createGame(input: $input) {
      id
      name
      gameId
      theoreticalReturnToPlayer
    }
  }
`

const GET_GAME = gql`
  query Game($input: GameQueryInput!) {
    game(input: $input) {
      id
      name
      gameId
      theoreticalReturnToPlayer
    }
  }
`

const EDIT_GAME = gql`
  mutation EditGame($input: EditGameInput!) {
    editGame(input: $input) {
      id
      name
      gameId,
      theoreticalReturnToPlayer
    }
  }
`

const DELETE_GAME = gql`
  mutation DeleteGame($input: DeleteGameInput!) {
    deleteGame(input: $input)
  }
`

const GET_GAME_VERSIONS = gql`
  query GameVersionPage($input: GameVersionPageInput!) {
    gameVersionPage(input: $input) {
      gameVersion {
        id
        gameId
        version
        frontendUrl
        backendUrl
        historyUrl
        jurisdictions{
          id
          key
          description
        }
        betSizes
      }
      totalCount
    }
  }
`

const CREATE_GAME_VERSION = gql`
  mutation CreateGameVersion($input: CreateGameVersionInput!) {
    createGameVersion(input: $input) {
      id
    }
  }
`

const GET_GAME_VERSION = gql`
  query GameVersion($input: GameVersionQueryInput!) {
    gameVersion(input: $input) {
      id
      version
      frontendUrl
      backendUrl
      historyUrl
      jurisdictions{
        id
      }
      betSizes
    }
  }
`

const EDIT_GAME_VERSION = gql`
  mutation EditGameVersion($input: EditGameVersionInput!) {
    editGameVersion(input: $input) {
      id
      version
      frontendUrl
      backendUrl
      historyUrl
      jurisdictions{
        id
      }
      betSizes
    }
  }
`

const DELETE_GAME_VERSION = gql`
  mutation DeleteGameVersion($input: DeleteGameVersionInput!) {
    deleteGameVersion(input: $input)
  }
`

export default {
  getGames () {
    return watchQuery({ query: GET_GAMES, variables: { input: { limit: 0, offset: 0 } } })
  },
  getGame (variables) {
    return watchQuery({ query: GET_GAME, variables })
  },
  getGameVersions (variables) {
    return watchQuery({ query: GET_GAME_VERSIONS, variables })
  },
  createGame (input) {
    return mutate({ mutation: CREATE_GAME, variables: { input } })
  },
  editGame (input) {
    return mutate({ mutation: EDIT_GAME, variables: { input } })
  },
  deleteGame (input) {
    return mutate({ mutation: DELETE_GAME, variables: { input} })
  },
  createVersion (input) {
    return mutate({ mutation: CREATE_GAME_VERSION, variables: { input } })
  },
  getVersion (variables) {
    return watchQuery({ query: GET_GAME_VERSION, variables })
  },
  editVersion (input) {
    return mutate({ mutation: EDIT_GAME_VERSION, variables: { input } })
  },
  deleteVersion (input) {
    return mutate({ mutation: DELETE_GAME_VERSION, variables: { input } })
  },
}
